<template>
    <div>
        <div v-for="(teamGroup, i) in teamGroups" :key="i"
             :class="[{'pagePaddingTop': i>0}, {'pageBreak': teamGroups.length>0}]">
            <div v-if="i>0" class="pb-4">
                <meisterschaft-print-header :lv-id="bewerb?.settings.lvId">
                    <meisterschaft-print-bewerb-name :bewerb="bewerb">
                        <span v-if="tab">
                            - <span class="text-uppercase">{{tab.title}}</span>
                        </span>
                    </meisterschaft-print-bewerb-name>
                </meisterschaft-print-header>
                <div v-if="bewerb && bewerb.getInfoText()" style="font-size: 16px; border-bottom: solid 1px #ddd; padding: 4px">
                    {{bewerb.getInfoText()}}</div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th class="text-left">Pos</th>
                        <th class="text-left">Name</th>
                        <th class="text-left">Verein</th>
                        <th>LV</th>
                        <th>AK</th>
                        <th>Volle</th>
                        <th>AR</th>
                        <th>FW</th>
                        <th>Ges</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(team, i) in teamGroup" :key="i">
                        <td class="text-center">
                            <span v-if="team.results.position===1000">-</span>
                            <span v-else-if="team.results.positionLos">{{ team.results.positionLos }}</span>
                            <span v-else>{{ team.results.position }}</span>
                        </td>
                        <!--<td :class="[{'lineDense': teamGroup.length>=16 || teamGroups.length>1},
                                     {'lineRegular': teamGroup.length>=8 && teamGroup.length<16 && teamGroups.length===1},
                                     {'lineLarge': teamGroup.length<8 && teamGroups.length===1}]">-->
                        <td class="lineDense">
                            {{team.settings.name}}
                            <div v-if="team.results.kommentar || team.results.status !== 'finished'" class="primary--text">
                            <span v-if="team.results.status !== 'finished'">
                                {{resultStatus.find(status => status.value === team.results.status)?.label}}</span>
                                <span v-if="team.results.kommentar"> ({{team.results.kommentar}})</span>
                            </div>
                            <v-chip small v-if="team.results.losEntscheid && !team.results.positionLos" color="primary">
                                <v-icon small class="mr-1">mdi-alert</v-icon>
                                Losentscheid erforderlich</v-chip>
                            <v-chip small v-if="team.results.positionLos" color="#666666" dark>
                                <v-icon small class="mr-1">mdi-information</v-icon>
                                Durch Los entschieden!</v-chip>
                        </td>
                        <td>{{team.settings.vereinsName}}</td>
                        <td class="text-center">{{team.settings.landesverband}}</td>
                        <td class="text-center">{{team.settings.ak}}</td>
                        <td class="text-center">{{team.results.volle}}</td>
                        <td class="text-center">{{team.results.abraeumen}}</td>
                        <td class="text-center">{{team.results.fehlwuerfe}}</td>
                        <td class="text-center">{{team.results.gesamt}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import {RESULT_STATUS} from "@/services/data/meisterschaften/bewerb_constants";
import MeisterschaftPrintBewerbName from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintBewerbName.vue";
import MeisterschaftPrintHeader from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintHeader.vue";

export default {
    name: "meisterschaftPrintRundeTab",
    components: {MeisterschaftPrintHeader, MeisterschaftPrintBewerbName},
    props: ['runde', 'bewerb', 'tab'],
    computed: {
        teamGroups(){ return this.runde.getTeamGroups(32) }
    },
    data: () => ({
        resultStatus: RESULT_STATUS
    }),
}
</script>

<style scoped>
    table {font-size: 14px; width: 100%; font-family: Roboto; border-collapse: collapse}
    th {padding: 0 4px 6px}
    td {padding-left: 4px; padding-right: 4px; border-top: solid 1px #ccc}
    .lineDense {padding-top: 1px; padding-bottom: 1px}
    /*.lineRegular {padding-top: 2px; padding-bottom: 2px}
    .lineLarge {padding-top: 6px; padding-bottom: 6px}*/
    .pageBreak {page-break-after: always;}
    .pagePaddingTop {padding-top: 1.5cm}
</style>